import { AdminConsoleSectionDetails } from "../../../../../../../types/adminConsoleTypes";
import { Table, TableBody, TableContainer, TableHead } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { AlertSpg, isArrayEmpty, isArrayNotEmpty, TableButton } from "@duosoftbg/nacid-components";
import React from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { openEditModal } from "../../../../../../../store/redux/slice/ComponentsControl/adminConsoleConfigControl";
import AdminConsoleSection from "./AdminConsoleSection";
import { acSectionCreationInitialValues } from "../../../../../../../init/adminConsoleCreationInitialValues";
import { adminConsoleSection } from "../../../../../../../utils/constants";
import AdminConsoleSectionDialog from "./dialog/AdminConsoleSectionDialog";
import AdminConsoleSectionDeleteDialog from "./dialog/AdminConsoleSectionDeleteDialog";
import AdminConsolePageDialog from "../page/dialog/AdminConsolePageDialog";
import AdminConsolePageDeleteDialog from "../page/dialog/AdminConsolePageDeleteDialog";

type AdminConsoleSectionListProps = {
  sections: AdminConsoleSectionDetails[];
};

const AdminConsoleSectionList = ({ sections }: AdminConsoleSectionListProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleCreateSection = () => {
    dispatch(openEditModal({ section: adminConsoleSection.section, object: acSectionCreationInitialValues }));
  };

  return (
    <>
      <AdminConsoleSectionDialog />
      <AdminConsoleSectionDeleteDialog />
      <AdminConsolePageDialog />
      <AdminConsolePageDeleteDialog />
      <TableContainer>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 35 }} />
              <TableCell>{t("l.table.head.id")}</TableCell>
              <TableCell>{t("l.table.head.section")}</TableCell>
              <TableCell>{t("l.table.head.section.en")}</TableCell>
              <TableCell>{t("l.table.head.position")}</TableCell>
              <TableCell align="right">
                <TableButton type={"create"} onClick={handleCreateSection} />
              </TableCell>
            </TableRow>
          </TableHead>
          {isArrayNotEmpty(sections) && (
            <TableBody>
              {sections.map((section) => (
                <AdminConsoleSection key={section.id} section={section} />
              ))}
            </TableBody>
          )}
        </Table>
        {isArrayEmpty(sections) && <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>}
      </TableContainer>
    </>
  );
};
export default AdminConsoleSectionList;
